export default __webpack_public_path__ + "static/media/PFP_logo_white.fc4ab1c8.png";